module.exports = __webpack_public_path__ + "img/traefik.1bbc5c12.svg";